import { type Insight } from "../../../../Pages/Insights/types";
import { useIsSupportUser } from "../hooks";
import { LoadingCard } from "../LoadingCard";
import { TopCard } from "../TopCard";

type SecurityInsightsCardProps = {
  securityInsights: Insight[];
  loading: boolean;
};

export const SecurityInsightsCard = ({ securityInsights, loading }: SecurityInsightsCardProps) => {
  const isSupportUser = useIsSupportUser();

  const insightsCount = securityInsights.length;

  if (loading) {
    return <LoadingCard title="Security risks" />;
  }
  return (
    <TopCard
      title="Security risks"
      value={insightsCount}
      trend="Security risks requiring attention"
      trendColor={insightsCount > 0 ? "error.main" : "success.main"}
      dataIcon={insightsCount > 0 ? "warning" : "check"}
      isValueInCurrency={false}
      disabled={isSupportUser}
      items={[
        {
          title: "Review and take action",
          path: "./optimize/insights",
          eventName: "Security risks",
          description: "Review and take action",
          locationState: {
            filterParam: {
              category: "categories",
              value: "Security",
            },
          },
        },
      ]}
    />
  );
};
